import styled from 'styled-components';
import { NARROW } from '@/breakpoints.js';
import { UI_TRANSITION } from '@/motion.js';

export const AppContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
	/* Mobile browsers: the area actually visible, without the retractable toolbars */
	height: 100dvh;
	width: 100vw;
	background-color: #282c34;
	position: fixed;
`;

// Floats over the canvas. Only its controls take pointer events, so the canvas underneath the
// rest of the bar can still be dragged.
export const Header = styled.header`
	box-sizing: border-box;
	width: 100%;
	position: absolute;
	inset-block-start: 0;
	inset-inline-start: 0;
	padding: 0.75em 1em;
	display: flex;
	align-items: center;
	gap: 1em;
	z-index: 2;
	pointer-events: none;

	${NARROW} {
		padding: 0.5em;
		gap: 0.5em;
	}
`;

// The logo leads back to the home page. The header lets clicks through to the canvas, so the link
// takes them back.
export const HomeLink = styled.a`
	display: block;
	flex-shrink: 0;
	pointer-events: auto;
`;

// Larger while a slideshow plays, as the title of what is shown: 1.8 times, twice on a phone. The file's width and
// height make a wider box than its drawing, which leaves empty room either side of the letters:
// large, it takes the drawing's own proportions, so that the letters sit as near the screen's
// edge as the title across from them.
export const Logo = styled.img<{ $large: boolean }>`
	display: block;
	height: ${({ $large }) => ($large ? 79 : 44)}px;
	${({ $large }) => ($large ? 'aspect-ratio: 341.415 / 120.501;' : '')}
	flex-shrink: 0;
	transition: height ${UI_TRANSITION};

	${NARROW} {
		height: ${({ $large }) => ($large ? 64 : 32)}px;
	}
`;
export const ViewportWrapper = styled.div`
	flex-grow: 1;
	min-height: 0;
	position: relative;
	background: #fff;
`;
export const LoadingMessage = styled.p`
	margin: 0;
	height: 100%;
	display: grid;
	place-items: center;
	color: #555;
	font-variant-numeric: tabular-nums;
`;
